import { SchoolLevel, UserFamilyMemberType } from 'src/types/user.types';
import { LessonSubject } from 'src/types/lesson.types';
import { readStoredItem, removeStoredItem, writeStoredItem } from 'src/utils/storageManager';

interface OnboardingData {
  firstname?: string;
  family_member_type?: UserFamilyMemberType;
  school_level?: SchoolLevel;
  education_level_code?: string;
  objectives?: string[];
  subjects?: LessonSubject[];
}

const ONBOARDING_STORAGE_KEY = 'onboarding_data';

const getStorageKey = (userId: number): string => {
  return `${ONBOARDING_STORAGE_KEY}_${userId}`;
};

export const saveOnboardingData = (
  userId: number,
  data: Partial<OnboardingData>,
): void => {
  const key = getStorageKey(userId);
  const existingData = getOnboardingData(userId);
  const updatedData = { ...existingData, ...data };
  writeStoredItem(key, JSON.stringify(updatedData));

  window.dispatchEvent(
    new CustomEvent('onboardingDataChanged', { detail: { userId } }),
  );
};

export const getOnboardingData = (userId: number): OnboardingData | null => {
  const key = getStorageKey(userId);
  const data = readStoredItem(key);
  if (!data) return null;
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};

export const clearOnboardingData = (userId: number): void => {
  const key = getStorageKey(userId);
  removeStoredItem(key);

  window.dispatchEvent(
    new CustomEvent('onboardingDataChanged', { detail: { userId } }),
  );
};

export const getAllOnboardingData = (userId: number): OnboardingData => {
  return getOnboardingData(userId) || {};
};
